import React from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import { Outlet } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

const MapLoader: React.FC = () => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? "YOUR_BACKUP_API_KEY";

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
    libraries: ["places", "geometry"],
  });

  if (loadError) {
    return (
      <Box textAlign="center" mt={5}>
        <Typography color="error">Error loading Google Maps</Typography>
      </Box>
    );
  }

  if (!isLoaded) {
    return (
      <Box textAlign="center" mt={5}>
        <CircularProgress />
        <Typography>Loading map...</Typography>
      </Box>
    );
  }

  // Outlet renders the child routes with the loader
  return <Outlet context={{ isLoaded }} />;
};

export default MapLoader;
